// extracted by mini-css-extract-plugin
export default {"root":"ServiceContractTable_root__7zWql","body2":"ServiceContractTable_body2__VE2Oc"};